// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"8f096a48","455":"b7e4a211","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};